<template>
<div class="pageContainer">

  <div class="size">
    <div class="title">{{'物件别部品不良推移'}}
      <el-select v-model="wuJianId" @change="renderAllEcharts" placeholder="物件名称" size="small" class="wujian_size">
        <el-option
            v-for="item in wuJianNames"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div class="chart_size" v-loading="wuJianChartLoading" element-loading-text="数据加载中" id="wuJianBuPin"/>
  </div>

  <div class="size">
    <div class="title">
      {{'供应商别部品不良推移'}}
      <div class="space-between">
        <el-date-picker v-model="supplierBad.year" @change="getSupplierChart" format="YYYY 年" value-format="YYYY" clearable type="year" placeholder="年" style="width: 80px; margin-right: 10px" size="small"/>
        <el-select v-model="supplierBad.supplier" @change="getSupplierChart" clearable placeholder="供应商" size="small" style="width: 180px">
          <el-option
              v-for="item in suppliers"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="chart_size" v-loading="supplierChartLoading" element-loading-text="数据加载中" id="supplierBuPin"/>
  </div>

</div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  name: "ShouRuBuPinPage",
  data(){
    return{
      wuJianId:'B00270',
      wuJianNames:[],
      suppliers:[],
      supplierBad:{
        supplier:'',
        year:new Date().getUTCFullYear().toString(),
      },
      /*物件别玻璃不良推移*/
      optionWuJian: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          //data: ['Evaporation', 'Precipitation', 'Temperature']
        },
        xAxis: [
          {
            type: 'category',
            data: [2104,2105,2106,2107,2108,2109,2110,2111,2112,2201,2202,2203],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '不良数量',
            min: 0,
            max: 10,
            interval: 2,
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            name: '不良率',
            min: 0,
            max: 100,
            interval: 20,
            axisLabel: {
              formatter: '{value}'
            }
          }
        ],
        series: [
          {
            name: '不良数量',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: [
              41, 63, 71, 15, 18, 23, 35, 46, 21, 23, 23, 41
            ]
          },
          {
            name: '目标',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + '%';
              }
            },
            data: [
              14, 12, 17, 15, 18, 23, 35, 46, 21, 23, 22, 24
            ]
          },
          {
            name: '实绩',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + '%';
              }
            },
            data: [24, 14, 36, 28, 10, 10, 18, 28, 23, 16, 12, 26]
          }
        ]
      },
      wuJianChartLoading:false,
      /*供应商别玻璃不良推移*/
      optionSupplier: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          //data: ['Evaporation', 'Precipitation', 'Temperature']
        },
        xAxis: [
          {
            type: 'category',
            data: [2104,2105,2106,2107,2108,2109,2110,2111,2112,2201,2202,2203],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '不良数量',
            min: 0,
            max: 250,
            interval: 50,
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            name: '不良率',
            min: 0,
            max: 100,
            interval: 20,
            axisLabel: {
              formatter: '{value}'
            }
          }
        ],
        series: [
          {
            name: '不良数量',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: [
              21, 33, 31, 51, 21, 33, 34, 45, 56, 12, 32, 12
            ]
          },
          {
            name: '目标',
            type: 'line',
            tooltip: {
              valueFormatter: function (value) {
                return value + '%';
              }
            },
            data: [
              23, 34, 43, 45, 56, 65, 75, 45, 43, 32, 21, 33
            ]
          },
          {
            name: '实绩',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + '%';
              }
            },
            data: [21, 32, 43, 45, 56, 67, 78, 98, 34, 23, 43, 32]
          }
        ]
      },
      supplierChartLoading:false,
    }
  },
  methods:{
    renderEcharts(id,option){
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let chart = echarts.init(document.getElementById(id));
        chart.setOption(option)
      }
    },

    renderAllEcharts(){
      this.getWuJianChart()
      this.getSupplierChart()
    },

    async getSuppliers() {
      let {data: res} = await this.$axios.post('bus/datasource/getAllData','bus_boli_zhijian_info.supplier_name');
      if (res.code !== 0) {
        this.$message.error('获取供应商失败')
        return;
      }
      this.suppliers = res.data;
    },

    async getWuJianInFo() {
      let {data: res} = await this.$axios.post('bus/datasource/getWuJianInFo');
      if (res.code !== 0) {
        this.$message.error('获取【物件信息】失败')
        return;
      }
      this.wuJianNames = res.data;
    },

    async getSupplierChart() {
      this.supplierChartLoading = true
      if (!this.supplierBad.year){
        this.supplierBad.year = new Date().getUTCFullYear().toString()
      }
      this.supplierBad.wujian_id = this.wuJianId
      let {data: res} = await this.$axios.post('bus/shouRuBoLi/supplierChart',this.supplierBad);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }
      /*this.optionBlend.xAxis[0].data = res.data.XMonth
      this.optionBlend.series[0].data = res.data.badNum
      if (this.optionBlend.yAxis[0].max < Math.max.apply(null,res.data.badNum)) {
        this.optionBlend.yAxis[0].max = Math.max.apply(null, res.data.badNum)
        this.optionBlend.yAxis[0].interval = Math.round(this.optionBlend.yAxis[0].max / 3)
      }*/
      this.renderEcharts('supplierBuPin',this.optionSupplier)

      this.supplierChartLoading = false
    },

    async getWuJianChart() {
      this.wuJianChartLoading = true

      let {data: res} = await this.$axios.post('bus/shouRuBoLi/wuJianChart',this.wuJianId);
      if (res.code !== 0) {
        this.$message.error(res.message)
        this.wuJianChartLoading = false
      }
      if (res.data.XMonth) {
        this.optionWuJian.xAxis[0].data = res.data.XMonth
        this.optionWuJian.series[0].data = res.data.badNum
        if (this.optionWuJian.yAxis[0].max < Math.max.apply(null, res.data.badNum)) {
          this.optionWuJian.yAxis[0].max = Math.max.apply(null, res.data.badNum)
          this.optionWuJian.yAxis[0].interval = Math.round(this.optionWuJian.yAxis[0].max / 3)
        }
      }
      this.renderEcharts('wuJianBuPin',this.optionWuJian)

      this.wuJianChartLoading = false
    },
  },

  created() {
    this.getWuJianInFo()
    this.getSuppliers()
  },

  mounted() {
    this.renderAllEcharts()
  }
}
</script>

<style scoped>
.pageContainer{
  display: flex;
  overflow: hidden;
  width: 100%;
  height: 700px;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}
.size{
  width: 870px;
  height: 325px
}
.title{
  border-left: 3px solid steelblue;
  height: 25px;
  font-size: 16px;
  padding-left: 10px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.space-between{
  display: flex;
  flex-direction: row;
  align-items: center;;
}
.chart_size{
  width: 870px;
  height: 300px
}
</style>